<template>
  <div id="admin-variant-character-group">
    <AdminVariantCharacterGroupHeader
      @onSearchVariantCharacterGroup="onSearchVariantCharacterGroup"
    />
    <el-divider></el-divider>
    <transition name="fade">
      <AdminVariantCharacterGroupList ref="variantCharacterGroupList" />
    </transition>
  </div>
</template>

<script>
import AdminVariantCharacterGroupHeader from "@/views/admin/AdminVariantCharacterGroupHeader.module.vue";
import AdminVariantCharacterGroupList from "@/views/admin/AdminVariantCharacterGroupList.module.vue";
import { apiErrorHandler } from "@/services/apiErrorHandler";

export default {
  components: {
    AdminVariantCharacterGroupHeader,
    AdminVariantCharacterGroupList,
  },
  methods: {
    /**
     * @param {object} options
     */
    async onSearchVariantCharacterGroup (options) {
      try {
        await this.$refs.variantCharacterGroupList.getVariantCharacterGroupsByFilterConditions(
          options
        );
      } catch (err) {
        apiErrorHandler(this, err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

#admin-variant-character-group {
  width: 99%;
  padding-left: 0.7rem;
}
#admin-variant-character-group .fade-enter-active,
#admin-variant-character-group .fade-leave-active {
  transition: opacity 0.3s;
}
#admin-variant-character-group .fade-enter,
#admin-variant-character-group .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#admin-variant-character-group > .el-divider {
  margin: 0;
}
</style>
